import { render, staticRenderFns } from "./divideMenu.vue?vue&type=template&id=2aca7404&scoped=true&"
import script from "./divideMenu.vue?vue&type=script&lang=js&"
export * from "./divideMenu.vue?vue&type=script&lang=js&"
import style0 from "./divideMenu.vue?vue&type=style&index=0&id=2aca7404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca7404",
  null
  
)

export default component.exports